'use client'
import { formatNumberToNumericalAbreviation } from 'utils/number'

import { useProductDataQuery } from '@web/hooks/use-product-data'

export function DownloadsValue({ defaultTotal }: { defaultTotal: number }) {
  const { data } = useProductDataQuery()
  const downloads = data?.downloads_count || 0

  return (
    <span data-testid="stat-downloads-value">
      {formatNumberToNumericalAbreviation(downloads || defaultTotal)}
    </span>
  )
}
